var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStarLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.9444 20.2444L59.1778 22.6111C62.0889 23.0333 63.2555 26.6222 61.1444 28.6778L49.4 40.1222L52.1778 56.2889C52.6778 59.2111 49.6 61.3889 47.0222 60.0333L32.5 52.4L17.9778 60.0333C15.4 61.4 12.3222 59.2111 12.8222 56.2889L15.6 40.1222L3.85554 28.6778C1.74443 26.6222 2.9111 23.0333 5.82221 22.6111L22.0555 20.2444L29.3111 5.53332C30.6222 2.87777 34.3889 2.9111 35.6889 5.53332L42.9444 20.2444Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStarLarge);
export default __webpack_public_path__ + "static/media/icon-star-large.c6cf10cf040d9d6d2d728ab33f07585b.svg";
export { ForwardRef as ReactComponent };